export default "__VITE_ASSET__386637af__$_?nuxt_component=async__"